import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-039b74a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "planning" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-8 p-4 flex items-center justify-between bg-white rounded-lg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uppercase font-semibold" }, "Начать планирование", -1))
const _hoisted_5 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "bg-white rounded" }
const _hoisted_9 = { class: "p-4 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-sm uppercase" }, "Секторы", -1))
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_13 = { class: "flex items-center justify-end mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none mt-6"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка данных планирования...", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении данных планирования произошла ошибка ", -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 mt-6"
}
const _hoisted_21 = {
  key: 2,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none mt-6"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка данных хранения...", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении данных хранения произошла ошибка ", -1))
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 3,
  class: "grid grid-cols-1 gap-4 mt-6"
}
const _hoisted_26 = { class: "w-1/2 ml-4" }
const _hoisted_27 = { class: "bg-white rounded p-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-sm uppercase" }, "Карта", -1))
const _hoisted_29 = { class: "bg-white rounded mt-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-4 border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-sm uppercase" }, "Курьеры")
], -1))
const _hoisted_31 = { class: "p-4" }
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка курьеров...", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении списка курьеров произошла ошибка ", -1))
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 1,
  class: "grid grid-cols-1 gap-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_container_invoice_panel_information = _resolveComponent("container-invoice-panel-information")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_set_invoices_wave_modal = _resolveComponent("set-invoices-wave-modal")!
  const _component_assign_containers_modal = _resolveComponent("assign-containers-modal")!
  const _component_assembly_containers_modal = _resolveComponent("assembly-containers-modal")!
  const _component_container_form = _resolveComponent("container-form")!
  const _component_move_invoice_form = _resolveComponent("move-invoice-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_loader = _resolveComponent("loader")!
  const _component_planning_record = _resolveComponent("planning-record")!
  const _component_new_map = _resolveComponent("new-map")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_planning_courier_record = _resolveComponent("planning-courier-record")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.invoice_state.is_opened && _ctx.invoice_state.invoice)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 0,
          title: _ctx.getModalTitle,
          "without-footer": "",
          "cheap-text": _ctx.getModalStatus,
          "cheap-class": _ctx.getCheapClass,
          onCancel: _ctx.closeInvoicePanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_container_invoice_panel_information, {
              "invoice-id": _ctx.invoice_state.invoice.id,
              onCancel: _ctx.closeInvoicePanel
            }, null, 8, ["invoice-id", "onCancel"])
          ]),
          _: 1
        }, 8, ["title", "cheap-text", "cheap-class", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.set_invoices_wave_state.is_opened)
      ? (_openBlock(), _createBlock(_component_set_invoices_wave_modal, {
          key: 1,
          "invoices-ids": _ctx.set_invoices_wave_state.invoiceIds,
          onCancel: _ctx.cancelSetInvoicesWave,
          onSubmit: _ctx.onSubmitSetInvoiceWave
        }, null, 8, ["invoices-ids", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.assign_containers_state.is_opened)
      ? (_openBlock(), _createBlock(_component_assign_containers_modal, {
          key: 2,
          "containers-ids": _ctx.assign_containers_state.containersIds,
          "city-ids": _ctx.new_dispatcher_store.dispatcherSectors.map((sector) => sector.cityId),
          "dispatcher-sector-ids": _ctx.new_dispatcher_store.dispatcherSectorIds,
          loading: _ctx.assign_containers_state.is_loading,
          onSubmit: _ctx.assignContainersToCourier,
          onCancel: _ctx.cancelAssignContainersToCourier
        }, null, 8, ["containers-ids", "city-ids", "dispatcher-sector-ids", "loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.assembly_containers_state.is_opened)
      ? (_openBlock(), _createBlock(_component_assembly_containers_modal, {
          key: 3,
          "wave-id": _ctx.filters_state.waveId,
          date: _ctx.filters_state.date,
          "sector-ids": _ctx.filters_state.sectorIds,
          loading: _ctx.assembly_containers_state.is_loading,
          onSubmit: _ctx.assemblyContainers,
          onCancel: _ctx.cancelAssemblyContainers
        }, null, 8, ["wave-id", "date", "sector-ids", "loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.new_container_state.is_opened)
      ? (_openBlock(), _createBlock(_component_container_form, {
          key: 4,
          loading: _ctx.new_container_state.is_loading,
          "dispatcher-sector-ids": _ctx.new_dispatcher_store.dispatcherSectorIds,
          "wave-id": _ctx.filters_state.waveId,
          date: _ctx.filters_state.date,
          onSubmit: _ctx.createContainer,
          onCancel: _ctx.cancelCreateNewContainer
        }, null, 8, ["loading", "dispatcher-sector-ids", "wave-id", "date", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.container_state.is_opened)
      ? (_openBlock(), _createBlock(_component_move_invoice_form, {
          key: 5,
          loading: _ctx.container_state.is_loading,
          "wave-id": _ctx.filters_state.waveId,
          "sector-ids": _ctx.filters_state.sectorIds,
          "invoice-ids": _ctx.container_state.invoiceIds,
          date: _ctx.filters_state.date,
          onSubmit: _ctx.manageContainerSubmit,
          onCancel: _ctx.manageContainerCancel
        }, null, 8, ["loading", "wave-id", "sector-ids", "invoice-ids", "date", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Планирование" }),
      _createVNode(_component_new_button, {
        class: "NewButton--outline",
        onClick: _ctx.toggleMapAndCouriers
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.getBtnClass)
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(_ctx.getBtnText), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_new_button, {
          class: "NewButton--outline",
          disabled: _ctx.generate_state.is_loading,
          loading: _ctx.generate_state.is_loading,
          onClick: _ctx.generateContainer
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Автоформирование контейнера ")
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"]),
        (_ctx.isCanAssemblyContainers)
          ? (_openBlock(), _createBlock(_component_new_button, {
              key: 0,
              class: "NewButton--outline",
              onClick: _ctx.startAssemblyContainers
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отправить на сборку ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getPlanningClass)
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (_ctx.isCanCreateContainer)
                ? (_openBlock(), _createBlock(_component_new_button, {
                    key: 0,
                    class: "NewButton--outline",
                    onClick: _ctx.startCreateNewContainer
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить контейнер ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_new_select, {
                  placeholder: "Волна",
                  "error-text": "При получении списка волн произошла ошибка",
                  "search-without-refresh": "",
                  label: "title",
                  value: _ctx.filters_state.waveId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.waveId) = $event)),
                  loading: _ctx.data_state.waves.is_loading,
                  failed: _ctx.data_state.waves.is_failed,
                  options: _ctx.data_state.waves.list,
                  "is-invalid": _ctx.filters$.waveId.$error,
                  "validation-errors": _ctx.filters$.waveId.$errors,
                  disabled: _ctx.state.is_loading,
                  onReload: _ctx.reloadWaves
                }, null, 8, ["value", "loading", "failed", "options", "is-invalid", "validation-errors", "disabled", "onReload"]),
                _createVNode(_component_new_input, {
                  type: "date",
                  placeholder: "Дата",
                  value: _ctx.filters_state.date,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.date) = $event)),
                  "is-invalid": _ctx.filters$.date.$error,
                  "validation-errors": _ctx.filters$.date.$errors,
                  disabled: _ctx.state.is_loading
                }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
                _createVNode(_component_new_select, {
                  placeholder: "Сектор",
                  "error-text": "При получении списка секторов произошла ошибка",
                  "search-without-refresh": "",
                  multiselect: "",
                  value: _ctx.filters_state.sectorIds,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.sectorIds) = $event)),
                  loading: _ctx.data_state.sectors.is_loading,
                  failed: _ctx.data_state.sectors.is_failed,
                  options: _ctx.data_state.sectors.list,
                  disabled: _ctx.state.is_loading,
                  onReload: _ctx.reloadSectors
                }, null, 8, ["value", "loading", "failed", "options", "disabled", "onReload"]),
                _createVNode(_component_new_input, {
                  placeholder: "Накладная",
                  value: _ctx.filters_state.invoiceNumber,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.invoiceNumber) = $event)),
                  disabled: _ctx.state.is_loading
                }, null, 8, ["value", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_new_button, {
                  class: "NewButton--reset mr-2",
                  disabled: _ctx.state.is_loading,
                  onClick: _ctx.onResetData
                }, {
                  "icon-left": _withCtx(() => [
                    _hoisted_14
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Сбросить ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_new_button, {
                  class: "NewButton--search",
                  disabled: _ctx.state.is_loading,
                  onClick: _ctx.loadData
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createTextVNode(" Поиск ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              (
                                    _ctx.state.is_loading ||
                                    _ctx.state.is_failed ||
                                    _ctx.state.records.length === 0
                                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_ctx.state.is_loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_loader, { class: "primary" }),
                          _hoisted_17
                        ], 64))
                      : (_ctx.state.is_failed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_18,
                            _createVNode(_component_new_button, {
                              class: "mt-1",
                              onClick: _ctx.loadData
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Перезагрузить ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_ctx.state.records.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Список данных планирования пуст"))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.records, (record) => {
                      return (_openBlock(), _createBlock(_component_planning_record, {
                        key: record.id,
                        record: record,
                        loading: _ctx.container_state.is_loading,
                        providers: _ctx.providers_state.list,
                        onMoveInvoiceToContainer: _ctx.startMoveInvoiceToContainer,
                        onDeleteInvoiceFromContainer: _ctx.deleteInvoiceFromContainer,
                        onDeleteContainer: _ctx.deleteContainer,
                        onAssignContainersToCourier: _ctx.startAssignContainersToCourier,
                        onOpenPanel: _ctx.openInvoicePanel,
                        onSetInvoicesWave: _ctx.startSetInvoicesWave,
                        onSelectInvoice: _ctx.selectInvoice,
                        onUnselectInvoice: _ctx.unselectInvoice
                      }, null, 8, ["record", "loading", "providers", "onMoveInvoiceToContainer", "onDeleteInvoiceFromContainer", "onDeleteContainer", "onAssignContainersToCourier", "onOpenPanel", "onSetInvoicesWave", "onSelectInvoice", "onUnselectInvoice"]))
                    }), 128))
                  ])),
              (
                                    _ctx.state.is_hold_loading ||
                                    _ctx.state.is_hold_failed ||
                                    _ctx.state.hold_records.length === 0
                                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_ctx.state.is_hold_loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_loader, { class: "primary" }),
                          _hoisted_22
                        ], 64))
                      : (_ctx.state.is_hold_failed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_23,
                            _createVNode(_component_new_button, {
                              class: "mt-1",
                              onClick: _ctx.loadData
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Перезагрузить ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_ctx.state.hold_records.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Список данных хранения пуст"))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.hold_records, (record) => {
                      return (_openBlock(), _createBlock(_component_planning_record, {
                        key: record.id,
                        record: record,
                        loading: _ctx.container_state.is_loading,
                        "is-hold": "",
                        onMoveInvoiceToContainer: _ctx.startMoveInvoiceToContainer,
                        onDeleteInvoiceFromContainer: _ctx.deleteInvoiceFromContainer,
                        onDeleteContainer: _ctx.deleteContainer,
                        onAssignContainersToCourier: _ctx.startAssignContainersToCourier,
                        onOpenPanel: _ctx.openInvoicePanel
                      }, null, 8, ["record", "loading", "onMoveInvoiceToContainer", "onDeleteInvoiceFromContainer", "onDeleteContainer", "onAssignContainersToCourier", "onOpenPanel"]))
                    }), 128))
                  ]))
            ])
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_new_map, {
              class: "planning__map mt-4",
              id: "planning-map",
              controls: ['zoomControl'],
              onMapReady: _ctx.onMapReady
            }, null, 8, ["onMapReady"]),
            _createVNode(_component_new_checkbox, {
              value: _ctx.maps_state.is_checked,
              disabled: _ctx.isMapCheckboxDisabled,
              label: "Без контейнера",
              class: "checkbox--red mt-3",
              "onUpdate:value": _ctx.onMapCheckboxChange
            }, null, 8, ["value", "disabled", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              (
                                    _ctx.couriers_state.is_loading ||
                                    _ctx.couriers_state.is_failed ||
                                    _ctx.couriers_state.couriers.length === 0
                                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_ctx.couriers_state.is_loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_loader, { class: "primary" }),
                          _hoisted_33
                        ], 64))
                      : (_ctx.couriers_state.is_failed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_34,
                            _createVNode(_component_new_button, {
                              class: "mt-1",
                              onClick: _ctx.reloadCouriers
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Перезагрузить ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_ctx.state.records.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_35, "Список курьеров пуст"))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couriers_state.couriers, (courier) => {
                      return (_openBlock(), _createBlock(_component_planning_courier_record, {
                        key: courier.id,
                        courier: courier
                      }, null, 8, ["courier"]))
                    }), 128))
                  ]))
            ])
          ])
        ], 512), [
          [_vShow, _ctx.state.is_map_opened]
        ])
      ])
    ])
  ]))
}